import React from 'react'

function FAQ() {
  return (
    <div>
        <div className="p-5 forestBackground">
            <h1 className="pt-3 display-5 fw-bold text-light">FAQ</h1>
            <p className="pb-3 col-md-5 fs-2 text-light fw-light">Resuelve tus dudas acerca de Carbono Zero.</p>
        </div>
        <div className='px-4 py-2'>
             <h1 className="col-12 py-5 mb-5 tittleText fw-bold">PREGUNTAS Y RESPUESTAS FRECUENTES</h1>

        </div>
    </div>
  )
}

export default FAQ